export enum TAXONOMY_CATEGORY {
  DEFAULT = 0,
  SAVED_TOPIC = 1,
}

export enum TOPIC_2_TYPE {
  AI = 1,
  RULE = 2,
  MANUAL = 3,
  SAVED_TOPIC = 4,
}

export enum PREDICTION_STATE {
  IDLE = 0,
  WAITING,
  TRAINING,
  SVM_CLASSIFICATION,
  LLM_CLASSIFICATION,
  RULE_CLASSIFICATION,
}

export enum HighlightTextTokenType {
  HIT = 'hit',
  TEXT = 'text',
}

export const MAX_TAXONOMY_COUNT = 6;

export const TAXONOMY_DND_ITEM = 'TAXONOMY_DND_ITEM';

export const draggableTopicType: TOPIC_2_TYPE[] = [
  TOPIC_2_TYPE.MANUAL,
  TOPIC_2_TYPE.AI,
];
